import { isNil } from 'lodash';
import { css } from 'styled-components';

export const spacing = {
  0: '0',
  2: '2px',
  4: '4px',
  8: '8px',
  12: '12px',
  16: '16px',
  20: '20px',
  24: '24px',
  32: '32px',
  40: '40px',
  48: '48px',
  56: '56px',
  64: '64px',
  72: '72px',
  80: '80px',
  108: '108px',
};

export interface SpacingProps {
  marginBottom?: keyof typeof spacing | null;
  marginLeft?: keyof typeof spacing | null;
  marginRight?: keyof typeof spacing | null;
  marginTop?: keyof typeof spacing | null;
}

export const spacingStyles = css<SpacingProps>`
  margin-bottom: ${({ marginBottom }) =>
    isNil(marginBottom) ? 0 : spacing[marginBottom]};
  margin-left: ${({ marginLeft }) =>
    isNil(marginLeft) ? 0 : spacing[marginLeft]};
  margin-right: ${({ marginRight }) =>
    isNil(marginRight) ? 0 : spacing[marginRight]};
  margin-top: ${({ marginTop }) => (isNil(marginTop) ? 0 : spacing[marginTop])};
`;
